import { inject, Injectable, signal } from "@angular/core";
import { Dropout } from "@interfaces";
import { FuncService } from "../../../../services";

@Injectable({ providedIn: 'root' })
export class DropoutDialogDataService {

	public dialogData = signal<Dropout | undefined>(undefined);
	private func = inject(FuncService);

	public async resetDialogData() {
		this.dialogData.set(undefined);
	}

	public async getDropoutDetails(dropoutId: number) {
		this.dialogData.set(await this.func.dropout.getDetailsById({ dropoutId }));
	}

}